import React from "react";
import { Translate } from "components/common/Translate/Translate";
import dynamic from "next/dynamic";

const PngResizeDimensionsImagePreview = dynamic<{ image?: string }>(
    () => import("components/features/PngResizer/PngResizeByDimensionsImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);
const PngFlexibleBackgroundImagePreview = dynamic<{ image?: string }>(
    () => import("components/features/PngResizer/PngFlexibleBackgroundImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

export const PngResizeByDimensions = ({ image }: { image?: string }) => {
    return (
        <>
            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 gap-2 hidden md:block">
                    <PngResizeDimensionsImagePreview image={image} />
                </div>
                <div className="text-left flex-1 dark:text-white md:text-left" style={{ marginTop: '-70px' }}>
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="PNG-Resize-by-Dimensions-or-Percentage-title" />
                    </h2>
                    <p className="md:pt-6">
                        <Translate keyName="PNG-Resize-by-Dimensions-or-Percentage-subtitle-1" />
                    </p>
                    <p className="md:pt-6 mt-2">
                        <Translate keyName="PNG-Resize-by-Dimensions-or-Percentage-subtitle-2" />
                    </p>
                </div>
                <div className="flex-1 gap-2  md:hidden">
                    <PngResizeDimensionsImagePreview image={image} />
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 dark:text-white text-center md:text-left order-2 md:order-1">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="Flexible-Background-title" />
                    </h2>
                    <p className="md:pt-6">
                        <Translate keyName="Flexible-Background-subtitle" />
                    </p>
                </div>
                <div className="flex-1 gap-2 hidden md:block order-1 md:order-2">
                    <PngFlexibleBackgroundImagePreview image={image} />
                </div>
            </div>
            <div className="flex-1 gap-2  md:hidden">
                <PngFlexibleBackgroundImagePreview image={image} />
            </div>
        </>
    );
};
